import { useTranslation } from "react-i18next";
import useWepapp from "./useWepapp";
import { Button, Col, ConfigProvider, Flex, Row, Switch } from "antd";
import { useState } from "react";
import styles from "../styles/PolicyCustomStyles.module.css";
import { useNavigate } from "react-router-dom";

const usePolicy = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isChecked, setIsChecked] = useState(false);

    const handleSwitchChange = (checked) => {
        setIsChecked(checked);
    };

    const onAccept = () => {
        if (isChecked) {
            navigate("/webapp/product");
        }
    }

    const p1 = t("webapp.label.policy")

    function p2() {
        return (
            <span style={{ textIndent: "5%", width: "100%" }}>
                นโยบายคุ้มครองข้อมูลส่วนบุคคลของ บริษัท ไบรต์ เอ็คซ์เพิร์ท จำกัด
            </span>
        )
    }

    function p3() {
        return (
            <span>หลักการและเหตุผล</span>
        )
    }

    function principle() {
        return (
            <span style={{ textAlign: "justify", textIndent: "5%" }}>
                บริษัท ไบรต์ เอ็คซ์เพิร์ท จำกัด ตระหนักถึงความสำคัญของการคุ้มครองข้อมูลส่วนบุคคลของท่านโดยนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ได้อธิบายการเก็บ รวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล รวมถึงสิทธิต่าง ๆ ของเจ้าของข้อมูลส่วน บุคคล  ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และกฎหมายที่เกี่ยวข้อง เพื่อให้ท่านมั่นใจว่าข้อมูลส่วนบุคคลของท่าน จะถูกนำไปใช้ตรงตามความต้องการของท่านและถูกต้องตามที่กฎหมายกำหนด
            </span>
        )
    }

    function p4() {
        return (
            <span>
                หมวด 1 คำนิยาม
            </span>
        )
    }

    function p5() {
        return (
            <span>
                หมวด 2 ข้อตกลงแสดงความยินยอมของผู้ใช้บริการ
            </span>
        )
    }

    function p6() {
        return (
            <span>
                หมวด 3 กระบวนการเก็บข้อมูลส่วนบุคคล
            </span>
        )
    }

    function p7() {
        return (
            <span style={{ width: "100%" }}>
                หมวด 4 การใช้ข้อมูลส่วนบุคคล
            </span>
        )
    }

    function p8() {
        return (
            <span style={{ width: "100%" }}>
                หมวด 5 การเปิดเผยข้อมูลส่วนบุคคล
            </span>
        )
    }

    function p9() {
        return (
            <span style={{ width: "100%" }}>
                หมวด 6 ข้อมูลตำแหน่งที่ตั้ง
            </span>
        )
    }

    function p10() {
        return (
            <span style={{ width: "100%" }}>
                หมวด 7 ระยะเวลาการเก็บข้อมูลส่วนบุคคล
            </span>
        )
    }

    function p11() {
        return (
            <span style={{ width: "100%" }}>
                หมวด 8 ความปลอดภัยของข้อมูล
            </span>
        )
    }

    function p12() {
        return (
            <span style={{ width: "100%" }}>
                หมวด 9 วิธีการติดต่อบริษัท
            </span>
        )
    }

    function policy1() {
        return (
            <>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อมแต่ไม่รวมถึงการระบุเฉพาะชื่อตำแหน่งสถานที่ทำงานหรือที่อยู่ทางธุรกิจและข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    “ข้อมูลส่วนบุคคลที่มีความอ่อนไหว” หมายความว่า ข้อมูลส่วนบุคคลเกี่ยวกับเชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ซึ่งกระทบต่อเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่กฎหมายกำหนด ซึ่งบริษัทจะเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวต่อเมื่อบริษัทได้รับความยินยอมโดยชัดแจ้งจากท่าน หรือในกรณีที่บริษัทมีความจำเป็นตามกรณีที่กฎหมายอนุญาต ทั้งนี้ บริษัทอาจต้องเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลข้อมูลชีวภาพ เช่น ข้อมูลภาพจำลองใบหน้า ข้อมูลจำลองลายนิ้วมือ ข้อมูลจำลองม่านตา ข้อมูลอัตลักษณ์เสียง เพื่อวัตถุประสงค์ในการพิสูจน์และยืนยันตัวตนของผู้ใช้บริการที่ขอสมัคร และ/หรือทำธุรกรรมผ่านช่องทางต่าง ๆ
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    “การประมวลผลข้อมูลส่วนบุคคล” หมายความว่า การดำเนินการใด ๆ ของบริษัทต่อข้อมูลส่วนบุคคลของลูกค้ารวมถึงการเก็บ รวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล และการลบข้อมูลส่วนบุคคล
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    “ผู้ควบคุมข้อมูลส่วนบุคคล” หมายความว่า บริษัทเป็นผู้ควบคุมข้อมูลส่วนบุคคลของลูกค้าทุกคน จึงมีหน้าที่และความรับผิดชอบต่อการประมวลผลและการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของลูกค้า การประมวลผลข้อมูลส่วนบุคคลจะกระทำเท่าที่จำเป็นแก่การให้บริการหรือเปิดเผยข้อมูลเพื่อดำเนินการตามคำขอ ซึ่งอาจรวมถึง การส่งเสริมการขาย การทำการตลาด แล้วแต่กรณี โดยมีวัตถุประสงค์ ขอบเขต และวิธีการใช้ตามที่กฎหมายกำหนด
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    “ผู้ประมวลผลข้อมูลส่วนบุคคล” หมายความว่า บริษัททำการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล ตามวัตถุประสงค์ ขอบเขต และวิธีการใช้ตามที่กฎหมายกำหนด
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    “ฐานข้อมูลลูกค้า” หมายความว่า ชุดข้อมูลเกี่ยวกับลูกค้าที่ลูกค้าได้ให้ไว้แก่บริษัทและบริษัทได้เก็บไว้เพื่อประโยชน์แก่การให้บริการ
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%", width: "100%" }}>
                    “บริษัท” หมายความว่า Bright Expert Co., Ltd. บริษัท ไบรต์ เอ็คซ์เพิร์ท จำกัด
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    “เครือข่ายทางสังคม” หมายความว่า บริการรับ และส่งข้อมูลสาธารณะ เช่น เฟสบุ๊ค ไลน์ ทวิตเตอร์ ฯลฯ เป็นต้น ที่บริษัทสนับสนุนอยู่
                </span>
            </>
        )
    }

    function policy2() {
        return (
            <>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    บริษัทอาจเก็บข้อมูลเกี่ยวกับผู้ใช้บริการเอาไว้หลากหลายรูปแบบซึ่งรวมถึงข้อมูลส่วนบุคคลที่ดำเนินการตามแนวนโยบายที่ได้กล่าวไว้นี้ “ข้อมูลส่วนบุคคล” คือข้อมูลที่ทำให้บุคคลอื่น ๆ สามารถระบุตัวตนของผู้ใช้บริการหรือติดต่อผู้ใช้บริการได้ ยกตัวอย่างเช่น ชื่อ ที่อยู่ เบอร์โทรศัพท์ ที่อยู่ทางจดหมายอิเล็กทรอนิกส์ เช่นเดียวกันกับข้อมูลที่ไม่เป็นสาธารณะที่เกี่ยวกับผู้ใช้บริการซึ่งผู้ใช้บริการเกี่ยวเนื่องด้วยหรือเชื่อมโยงกับข้อมูลก่อนหน้าใด ๆ บริษัทจะดำเนินการต่อข้อมูลส่วนบุคคลของผู้ใช้บริการตามหลักเกณฑ์ของกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ทั้งนี้การดำเนินการดังกล่าวเป็นไปเพื่อความจำเป็นในการจัดหาบริการแก่ผู้ใช้บริการเท่านั้น
                </span>
                <Row style={{ rowGap: "1vh" }}>
                    <span style={{ textIndent: "5%", width: "100%" }}>
                        บริษัทจะดำเนินการเก็บรวบรวมใช้และ/หรือเปิดเผยซึ่งข้อมูลส่วนบุคคลของผู้ใช้บริการในกรณีดังต่อไปนี้
                    </span>
                    <ul style={{ paddingInlineStart: "5%" }}>
                        <li>เมื่อผู้ใช้บริการได้แสดงความยินยอม</li>
                        <li>เมื่อมีความจำเป็นในการให้บริการแก่ผู้ใช้บริการ</li>
                        <li style={{ textAlign: "justify" }}>เมื่อมีความจำเป็นในการตอบสนองต่อข้อเรียกร้องของผู้ใช้บริการ</li>
                        <li style={{ textAlign: "justify" }}>เมื่อมีความจำเป็นในการรักษาบัญชีผู้ใช้ ของผู้ใช้บริการเอาไว้กับบริษัท</li>
                        <li style={{ textAlign: "justify" }}>เมื่อมีเหตุจำเป็นสำหรับการปฏิบัติตามหน้าที่ทางกฎหมายและหน้าที่ตามกฎเกณฑ์ของบริษัท</li>
                    </ul>
                </Row>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    ในกรณีตาม (หมวด 2) ข้างต้น ผู้ใช้บริการสามารถถอนความยินยอม ณ เวลาใด ๆ โดยการแสดงเจตนาดังที่กล่าวไว้ การถอนความยินยอมจะต้องไม่ส่งผลกระทบต่อความชอบธรรมของการนำข้อมูลส่วนบุคคลไปใช้ก่อนมีการถอนความยินยอมนั้น หากผู้ใช้บริการไม่เห็นด้วยกับการที่ทางบริษัทใช้ข้อมูลส่วนบุคคลของผู้ใช้บริการตามกฎเกณฑ์ของนโยบายฉบับนี้ผู้ใช้บริการสามารถไม่ใช้บริการกับบริษัทได้
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    นอกจากนี้ บริษัทอาจส่งข้อมูลส่วนบุคคลของท่านให้กับหน่วยงานหรือบุคคลภายนอกดำเนินการในฐานะ “ผู้ประมวลผลข้อมูลส่วนบุคคล” โดยดำเนินการในนามของบริษัท
                </span>
            </>
        )
    }

    function policy3() {
        return (
            <>
                <span style={{
                    textAlign: "justify", textIndent: "5%"
                }}>
                    3.1 ประเภทข้อมูลที่ผู้ใช้บริการได้ให้ไว้กับบริษัทโดยการทั่วไป บริษัทจะได้รับข้อมูลจากการส่งข้อมูลกรอกใบสมัครของผู้ใช้บริการในระหว่างที่ผู้ใช้บริการเป็นลูกค้าของบริษัท ซึ่งบริษัทได้เก็บข้อมูลของผู้ใช้บริการเอาไว้เมื่อผู้ใช้บริการทำการลงทะเบียนหรือสมัครรับบริการใดบริการหนึ่งของบริษัท การส่งคำสั่ง การเข้าถึงและการใช้บริการออนไลน์ของบริษัทหรือแม้กระทั่งการคลิกเข้าไปยังลิงก์ของบริษัทที่ปรากฏบนหน้าโฆษณาใด ๆ ของบริษัท การขอความช่วยเหลือด้านข้อมูล หรืองานบริการลูกค้า การตอบกลับหลังจากใช้บริการ หรือแม้แต่การตอบแบบสอบถามโดยอาจเป็นเงื่อนไขที่ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวของผู้ใช้บริการแก่บริษัทเพื่อที่บริษัทจะสามารถจัดการธุรกิจและการดำเนินงานของบริษัท เพื่อการรักษาสัมพันธ์ที่ดีระหว่างบริษัทและตัวผู้ใช้บริการเพื่อจัดหาสินค้าและบริการที่เหมาะสมแก่ผู้ใช้บริการโดยคำนึงถึงกฎหมายและกฎเกณฑ์ของทางบริษัท หากผู้ใช้บริการไม่ได้ปฏิบัติตามข้อกำหนด หรือไม่ได้ให้ข้อมูลส่วนบุคคลกับบริษัท บริษัทอาจไม่สามารถให้บริการสินค้าหรือบริการแก่ผู้ใช้บริการต่อไป
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    3.2 ประเภทข้อมูลที่บริษัทได้รับจากทางอื่น ซึ่งเป็นข้อมูลที่เป็นสาธารณะ หรือที่สามารถเผยแพร่ข้อมูลส่วนบุคคลได้อย่างถูกต้องตามกฎหมาย เช่น จากบริษัท ตัวแทนอ้างอิงทางเครดิต หรือสื่อสังคมออนไลน์ บริษัทอาจได้รับข้อมูลส่วนบุคคลเหล่านี้ของผู้ใช้บริการจากบริษัทต่างๆ ที่ได้ให้บริการโดยมีผลิตภัณฑ์ ยี่ห้อสินค้า หรือเว็บไซต์ส่วนบุคคลซึ่งเสนอสินค้า และ/หรือบริการของบริษัทนั้นๆร่วมกันกับบริษัทบริษัทบุคคลที่สามเหล่านี้ มีสิทธิโดยชอบด้วยกฎหมายที่จะให้ข้อมูลส่วนบุคคลของผู้ใช้บริการแก่บริษัทได้ บริษัทอาจเพิ่มข้อมูลนี้ไปยังฐานข้อมูลที่บริษัทมีอยู่แล้วจากเว็บไซต์ของบริษัทเพื่อเป็นการพัฒนาการให้บริการ
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    3.3 ประเภทข้อมูลจากเว็บไซต์ในการเข้าถึงคุณลักษณะและทางเลือกการใช้งานอย่างหนึ่งอย่างใดได้นั้น ผู้ใช้บริการอาจจำต้องเข้าใช้บริการโดยลงชื่อเข้าใช้งานผ่าน เฟสบุ๊ค หรือเว็บไซต์เครือข่ายทางสังคมอื่น ๆ โดยการลงชื่อเข้าใช้งานดังกล่าว จะถือว่าผู้ใช้บริการได้อนุญาตให้บริการต่าง ๆ สามารถเข้าถึงข้อมูลของผู้ใช้บริการ และผู้ใช้บริการได้ตอบตกลงการขอรับการบริการในข้อตกลงการใช้งานของเว็บไซต์เครือข่ายทางสังคม หากผู้ใช้บริการไม่ได้ลงทะเบียนเป็นผู้ใช้งานการบริการ และกดปุ่ม “ลงทะเบียน” หรือ “ลงชื่อเข้าใช้” ผ่านเว็บไซต์เครือข่ายทางสังคมที่บริษัทสนับสนุนอยู่ ผู้ใช้บริการจะถูกสอบถามให้กรอกข้อมูลส่วนบุคคลโดยข้อมูลส่วนบุคคลเหล่านั้นจะถูกจัดเก็บอยู่ในฐานข้อมูลของเครือข่ายทางสังคม ทั้งนี้ผู้ใช้บริการสามารถตัดสินใจลงทะเบียนใช้งานบริการหรือไม่ก็ได้ ในกรณีนี้บริษัทอาจได้รับข้อมูลส่วนบุคคลดังกล่าวจากเว็บไซต์เครือข่ายทางสังคมเพื่ออำนวยความสะดวกให้แก่ผู้ใช้บริการในการสร้างบัญชีผู้ใช้ขึ้นจากเว็บไซต์และเพื่อแสดงเนื้อหาสาระของบริษัทจากเพื่อนในเว็บไซต์เครือข่ายทางสังคมของผู้ใช้บริการเองข้อมูลใด ๆ ก็ตามของผู้ใช้บริการที่บริษัทดำเนินการจัดเก็บจากบัญชีเว็บไซต์เครือข่ายทางสังคมอาจขึ้นอยู่กับการตั้งค่าความเป็นส่วนตัวของผู้ใช้บริการต่อเว็บไซต์เครือข่ายทางสังคมนั้น ๆ ซึ่งบริษัทไม่มีส่วนเกี่ยวข้อง และไม่มีความรับผิดชอบต่อข้อมูลส่วนบุคคลของผู้ใช้บริการที่ให้ไว้แก่เว็บไซด์เครือข่ายทางสังคมนั้น ๆ ดังนั้นกรุณาศึกษาแนวปฏิบัติด้านความเป็นส่วนตัวและข้อมูลของเว็บไซต์เครือข่ายทางสังคมโดยละเอียด
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    3.4 ข้อมูลอื่น ๆ ที่จัดเก็บโดยเทคโนโลยี บริษัทอาจใช้คุกกี้ (“คุกกี้”) เพื่ออำนวยความสะดวกในการใช้งานของผู้ใช้บริการให้ดียิ่งขึ้น คุกกี้คือชิ้นส่วนของข้อมูลขนาดเล็กซึ่งเว็บไซต์ต่าง ๆ ส่งเข้ามายังฮาร์ดไดร์ฟของเครื่องคอมพิวเตอร์ของผู้ใช้บริการในขณะที่ผู้ใช้บริการกำลังเปิดดูเว็บไซต์อยู่ บริษัทอาจใช้คุกกี้ทั้งสองช่วง (ซึ่งจะหมดอายุทันทีที่ผู้ใช้บริการปิดโปรแกรมท่องเว็บ) และคุกกี้คงสภาพต่าง ๆ (ซึ่งจะคงอยู่ในเครื่องคอมพิวเตอร์ของผู้ใช้บริการตราบจนกว่าผู้ใช้บริการจะลบออกไป) เพื่อให้การบริการประสบการณ์เฉพาะบุคคล และเชิงตอบสนองซึ่งกันและกันได้ให้แก่ผู้ใช้บริการบนเว็บไซต์ต่าง ๆ ของบริษัทข้อมูลชนิดนี้จะถูกเก็บรวบรวมเพื่อทำให้เว็บไซต์ทั้งหลายของบริษัทสมประโยชน์ต่อการใช้งานมากขึ้นหากผู้ใช้บริการต้องการปิดการใช้งานคุกกี้ ผู้ใช้บริการสามารถตั้งค่าได้ที่โปรแกรมท่องเว็บของผู้ใช้บริการเพื่อปฏิเสธหรือปิดกั้นคุกกี้เหล่านั้นได้ อย่างไรก็ตามหากผู้ใช้บริการทำการปฏิเสธหรือปิดกั้นเช่นนั้นแล้ว ผู้ใช้บริการอาจไม่สามารถเปิดการใช้งานเว็บไซต์ของบริษัทได้อย่างเต็มรูปแบบ
                </span>
            </>
        )
    }

    function policy4() {
        return (
            <>
                <span style={{ textAlign: "justify", textIndent: "5%", width: "100%" }}>
                    ข้อมูลส่วนบุคคลชนิดต่าง ๆ ขอบเขตการใช้งานข้อมูลส่วนบุคคล
                </span>
                <Row style={{ rowGap: "1vh", width: "100%" }}>
                    <span style={{ textIndent: "5%", width: "100%" }}>
                        ชื่อ
                    </span>
                    <ul style={{ listStyleType: "disc", paddingInlineStart: "5%" }}>
                        <li style={{ textAlign: "justify" }}> เพื่อยืนยันตัวตนสำหรับการสั่งซื้อสินค้าหรือบริการของผู้ใช้บริการ</li>
                        <li style={{ textAlign: "justify" }}>เพื่อให้บริการแก่ผู้ใช้บริการเช่นการตอบคำถามและคำร้องเรียนต่าง ๆ </li>
                        <li style={{ textAlign: "justify" }}>เพื่อส่งรายการปรับปรุงให้เป็นปัจจุบัน</li>
                        <li style={{ textAlign: "justify" }}>เพื่อตรวจจับและป้องกันการทุจริตต่อผู้ใช้บริการและต่อบริษัทเอง</li>
                    </ul>
                </Row>
                <Row style={{ rowGap: "1vh" }}>
                    <span style={{ textIndent: "5%", width: "100%" }}>เบอร์โทรศัพท์</span>
                    <ul style={{ listStyle: "disc", paddingInlineStart: "5%" }}>
                        <li>เพื่อใช้สำหรับการติดต่อ</li>
                        <li>เพื่อให้บริการแก่ผู้ใช้บริการ เช่น การตอบคำถามหรือข้อร้องเรียนต่าง ๆ ของผู้ใช้บริการ</li>
                        <li>เพื่อส่งรายการปรับปรุงให้เป็นปัจจุบัน</li>
                    </ul>
                </Row>
                <Row style={{ rowGap: "1vh", width: "100%" }}>
                    <span style={{ textIndent: "5%", width: "100%" }}>
                        ที่อยู่จดหมายอิเล็กทรอนิกส์
                    </span>
                    <ul style={{ listStyle: "disc", paddingInlineStart: "5%" }}>
                        <li>เพื่อใช้สำหรับการติดต่อ</li>
                        <li style={{ textAlign: "justify" }}>เพื่อใช้ในการติดต่อกับผู้ใช้บริการเกี่ยวกับบัญชีของผู้ใช้บริการที่มีอยู่กับบริษัท เช่น การยืนยันการลงทะเบียนเปิดบัญชีใหม่</li>
                        <li>เพื่อให้บริการแก่ผู้ใช้บริการ เช่น การตอบคำถามหรือข้อร้องเรียนต่าง ๆ ของผู้ใช้บริการ</li>
                        <li>เพื่อส่งรายการปรับปรุงให้เป็นปัจจุบัน</li>
                    </ul>
                </Row>
                <Row style={{ rowGap: "1vh" }}>
                    <span style={{ textIndent: "5%", width: "100%" }}>
                        ที่อยู่จดหมายและประเทศ
                    </span>
                    <ul style={{ listStyle: "disc", paddingInlineStart: "5%" }}>
                        <li>เพื่อการจัดส่งใบยืนยันการซื้อสินค้าหรือบริการ/ เอกสารการชำระราคา/ ใบกำกับภาษี</li>
                        <li>เพื่อให้บริการแก่ผู้ใช้บริการ เช่น การตอบคำถามหรือข้อร้องเรียนต่าง ๆ ของผู้ใช้บริการ</li>
                        <li>เพื่อส่งรายการปรับปรุงให้เป็นปัจจุบัน</li>
                        <li>เพื่อตรวจจับและป้องกันการทุจริตต่อผู้ใช้บริการและต่อบริษัทเอง</li>
                    </ul>
                </Row>
                <Row style={{ rowGap: "1vh" }}>
                    <span style={{ textIndent: "5%", width: "100%" }}>
                        วัน/เดือน/ปีที่เกิด
                    </span>
                    <ul style={{ listStyle: "disc", paddingInlineStart: "5%" }}>
                        <li>เพื่อยืนยันอายุของผู้ใช้บริการ</li>
                        <li>เพื่อตรวจจับและป้องกันการทุจริตต่อผู้ใช้บริการและต่อบริษัทเอง</li>
                    </ul>
                </Row>
                <Row style={{ rowGap: "1vh" }}>
                    <span style={{ textIndent: "5%", width: "100%" }}>
                        ประวัติการซื้อสินค้า
                    </span>
                    <ul style={{ listStyle: "disc", paddingInlineStart: "5%" }}>
                        <li>เพื่อเก็บเป็นหลักฐานแสดงการซื้อสินค้าหรือรับบริการจากบริษัท</li>
                        <li>เพื่อตรวจจับและป้องกันการทุจริตต่อผู้ใช้บริการและต่อบริษัทเอง</li>
                    </ul>
                </Row>
            </>
        )
    }

    function policy5() {
        return (
            <>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    5.1 ผู้ใช้บริการตกลงยินยอมให้บริษัทติดต่อสอบถาม เก็บรวบรวมข้อมูลส่วนบุคคลและข้อมูลการใช้บริการของผู้ใช้บริการกับบริษัท และยินยอมให้บริษัทส่ง โอน ใช้และ/หรือเปิดเผยข้อมูลส่วนบุคคลให้แก่ผู้สอบบัญชีผู้ตรวจสอบภายนอกของบริษัท สถาบันการเงิน หน่วยงานราชการมีอำนาจตามกฎหมาย และ/หรือเพื่อตรวจสอบรายการธุรกรรมที่อาจจะเกิดการทุจริต และ/หรือเพื่อวัตถุประสงค์อื่นใดที่ไม่ต้องห้ามโดยกฎหมาย และ/หรือเพื่อปฏิบัติตามกฎหมายหรือกฎระเบียบของประเทศใด ๆ ที่ใช้บังคับกับบริษัท และ/หรือเพื่อวัตถุประสงค์อื่นใดที่จำเป็นกับการบริการของบริษัท
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    5.2 ผู้ใช้บริการยอมรับว่าบันทึกหลักฐานหรือเอกสารใด ๆ ที่บริษัทได้จัดทำขึ้น เนื่องจากการใช้บริการของผู้ใช้บริการมีความถูกต้องโดยไม่จำเป็นต้องให้ผู้ใช้บริการตรวจสอบหรือลงลายมือชื่อก่อนแต่อย่างใด และสามารถใช้เป็นพยานหลักฐานในการพิสูจน์มูลหนี้การหักเงินการโอนเงิน และ/หรือการใช้บริการใด ๆ ได้โดยชอบ แม้ว่าข้อมูลนั้นจะเก็บรักษาและ/หรือรวบรวมไว้ในรูปแบบของข้อมูลทางอิเล็กทรอนิกส์ หรือไม่ว่าในรูปแบบใดก็ตามทั้งนี้ผู้ใช้บริการมีสิทธิที่จะได้รับเอกสารหลักฐานประกอบการทำรายการของผู้ใช้บริการ
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    5.3 ข้อมูลส่วนบุคคลของผู้ใช้บริการ และการเปิดเผยข้อมูลส่วนบุคคลต่อผู้ให้บริการ ผู้ใช้บริการยอมรับและตกลงที่จะเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการ เช่น ชื่อ วันเดือนปีเกิด ที่อยู่ และรายละเอียดที่จำเป็นสำหรับการเรียกชำระเงินและการให้และรับบริการอำนวยความสะดวกจากบริษัทและผู้ให้บริการซึ่งเป็นบุคคลภายนอก โดยสมัครใจอันรวมถึงลูกจ้างและ/หรือตัวแทนของผู้ให้บริการเพื่อวัตถุประสงค์ในการให้บริการของแอพพลิเคชั่นและการให้บริการอำนวยความสะดวก ในการนี้บริษัทจะให้ผู้ให้บริการซึ่งเป็นบุคคลภายนอกเข้าทำข้อตกลงประมวลผลข้อมูลส่วนบุคคลกับบริษัท ก่อนที่จะเปิดเผยข้อมูลของผู้ใช้บริการ เพื่อให้ผู้ให้บริการต้องดำเนินการเก็บรักษาข้อมูลส่วนบุคคลของผู้ใช้บริการให้สอดคล้องกับนโยบายการคุ้มครองข้อมูลส่วนบุคคลของบริษัทตามที่ได้แจ้งไว้ต่อผู้ใช้บริการ และมีมาตรการคุ้มครองข้อมูลส่วนบุคคลตามมาตรฐานของบริษัท
                </span>
                <span style={{ textIndent: "5%" }}>
                    5.4 กฎหมายที่ใช้บังคับข้อตกลงและเงื่อนไขนี้ จะต้องถูกตีความและควบคุมโดยกฎหมายที่บังคับใช้ในราชอาณาจักรไทย
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    5.5 ความสมบูรณ์ของข้อตกลงและเงื่อนไข หากข้อกำหนดเงื่อนไขหรือข้อตกลงใด ๆ ในนโยบายฉบับนี้ตกเป็นโมฆะไม่สมบูรณ์ขัดต่อกฎหมายหรือใช้บังคับไม่ได้ไม่ว่ากรณีใด ๆ ให้ข้อกำหนดเงื่อนไขหรือข้อตกลงที่เป็นโมฆะไม่สมบูรณ์ขัดต่อกฎหมายหรือใช้บังคับไม่ได้นั้นแยกต่างหากจากข้อกำหนด เงื่อนไข หรือข้อตกลงส่วนที่สมบูรณ์และให้ข้อกำหนดเงื่อนไขหรือข้อตกลงส่วนที่สมบูรณ์นั้นใช้บังคับได้ต่อไป
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    5.6 บริษัทอาจปรับปรุงหรือแก้ไขนโยบายคุ้มครองข้อมูลส่วนบุคคล โดยไม่ได้แจ้งให้ผู้ใช้บริการทราบล่วงหน้า การที่ผู้ใช้บริการใช้บริการต่อไป ถือว่าผู้ใช้ได้ให้การยอมรับที่มีผลสมบูรณ์และเพิกถอนมิได้ต่อข้อกำหนดและเงื่อนไขฯ ที่แก้ไขหรือเพิ่มเติมแล้วผู้ใช้บริการควรตรวจสอบข้อกำหนดและเงื่อนไขฯ เป็นประจำระหว่างการใช้บริการ เนื่องจากอาจไม่มีการแจ้งเตือนแยกต่างหากเกี่ยวกับการแก้ไขข้อกำหนดและเงื่อนไขฯ ดังกล่าวทั้งนี้เพื่อความเหมาะสมและมีประสิทธิภาพในการให้บริการรวมถึงหลักเกณฑ์ของกฎหมายที่เปลี่ยนแปลง
                </span>
            </>
        )
    }

    function policy6() {
        return (
            <span style={{ textAlign: "justify", textIndent: "5%" }}>
                หากผู้ใช้บริการได้ทำการเปิดการใช้งานบริการด้านตำแหน่งที่ตั้งบนโทรศัพท์ของผู้ใช้บริการ บริษัทอาจจะเก็บข้อมูลตำแหน่งที่ตั้งของผู้ใช้บริการเพื่อทำให้แผนที่นั้นสามารถเปิดการใช้งานได้แก่ผู้รับสารจากผู้ใช้บริการโดยจะแสดงตำแหน่งที่ตั้งของผู้ใช้บริการแก่ผู้รับสารหากผู้ใช้บริการไม่ต้องการให้ข้อมูลนี้ถูกจัดเก็บผู้ใช้บริการสามารถปิดการใช้งานบริการด้านข้อมูลตำแหน่งที่ตั้งได้ในแถบตั้งค่าของโทรศัพท์มือถือของผู้ใช้บริการ
            </span>
        )
    }

    function policy7() {
        return (
            <span style={{ textAlign: "justify", textIndent: "5%" }}>
                บริษัทจะจัดเก็บข้อมูลส่วนบุคคลของผู้ใช้บริการไว้เพียงเท่าที่ผู้ใช้บริการมีบัญชีผู้ใช้กับบริษัท หรือนานเท่าที่บริษัทจำเป็นต้องให้บริการแก่ผู้ใช้บริการหากมีเหตุผลอันสมควรเพื่อการปฏิบัติตามกฎหมาย กฎเกณฑ์ ข้อบังคับ หรือความจำเป็นเชิงนโยบายภายใน บริษัทอาจทำการจัดเก็บข้อมูลส่วนบุคคลของผู้ใช้บริการเอาไว้
            </span>
        )
    }

    function policy8() {
        return (
            <>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    บริษัทมีความมุ่งมั่นที่จะปกป้องและดูแลข้อมูลส่วนบุคคลของผู้ใช้บริการจะใช้และรักษาวิธีการดำเนินการที่เหมาะสมทั้งในเชิงเทคนิคและเชิงองค์กร เพื่อรับประกันระดับความปลอดภัยที่เหมาะสมกับการปกป้องข้อมูลส่วนบุคคลของผู้ใช้บริการจากอุบัติเหตุ หรือการถูกทำลายที่ไม่ได้รับอนุญาต การสูญหาย การเปลี่ยนแปลง การเปิดเผย หรือการเข้าถึง อย่างไรก็ตามไม่มีการถ่ายเทข้อมูลทางอินเตอร์เน็ตใดที่จะปลอดภัยโดยสมบูรณ์ หากผู้ใช้บริการมีเหตุผลที่เชื่อได้ว่าการตอบโต้ของผู้ใช้บริการต่อบริษัทไม่ปลอดภัยอีกต่อไป (ยกตัวอย่างเช่น หากผู้ใช้บริการรู้สึกว่าความปลอดภัยของบัญชีใดๆ ที่ผู้ใช้บริการมีกับบริษัทอาจได้รับอันตราย) โปรดแจ้งให้บริษัททราบถึงปัญหาดังกล่าวทันที โดยสามารถทจำการติดต่อบริษัทโดยใช้ข้อมูลด้านล่างหมวด 10 สิทธิและทางเลือกของผู้ใช้บริการต่อข้อมูลส่วนบุคคล
                </span>
                <Row style={{ rowGap: "1vh" }}>
                    <span style={{ textAlign: "justify", textIndent: "5%" }}>
                        8.1 ภายใต้สถานการณ์ต่างๆนั้นผู้ใช้บริการได้กระทำตามสิทธิของผู้ใช้บริการโดยเกี่ยวเนื่องกับการดำเนินการของบริษัทเกี่ยวกับข้อมูลส่วนบุคคลของผู้ใช้บริการ
                    </span>
                    <ul style={{ listStyle: "disc", paddingInlineStart: "5%" }}>
                        <li style={{ textAlign: "justify" }}>
                            สิทธิที่จะได้รับการยืนยันว่าตามข้อมูลส่วนบุคคลและข้อมูลเสริมอื่น ๆ ของผู้ใช้บริการกำลังถูกดำเนินการและได้รับการประเมิน
                        </li>
                        <li>
                            สิทธิที่จะได้รับการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง
                        </li>
                        <li>
                            สิทธิที่จะลบข้อมูลส่วนบุคคลและยับยั้งการดำเนินการใด ๆ เกี่ยวกับข้อมูลนั้น
                        </li>
                        <li>
                            สิทธิที่จะจำกัดการดำเนินการเกี่ยวกับข้อมูล
                        </li>
                        <li>
                            สิทธิที่จะเคลื่อนย้ายข้อมูล
                        </li>
                        <li>
                            สิทธิที่จะคัดค้านการดำเนินการเกี่ยวกับข้อมูลส่วนบุคคล
                        </li>
                        <li>
                            สิทธิที่จะขอยกเลิกการใช้บริการการสื่อสารและการตลาดทางจดหมายอิเล็กทรอนิกส์
                        </li>
                    </ul>
                </Row>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    8.2 หากผู้ใช้บริการปรารถนาที่จะใช้สิทธิใด ๆ โปรดติดต่อบริษัทโดยใช้ข้อมูลติดต่อที่จัดไว้ให้ด้านล่าง บริษัทอาจขอให้ผู้ใช้บริการพิสูจน์ และยืนยันตัวตนโดยการมอบสำเนาเอกสาร หรือหลักฐานการระบุตัวตนที่ถูกต้อง เพื่อที่บริษัทจะสามารถปฏิบัติตามข้อกำหนดความปลอดภัยของบริษัท และป้องกันการเปิดเผยข้อมูลที่ไม่ได้รับอนุญาต
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    8.3 หากผู้ใช้บริการไม่ปรารถนาที่จะยอมรับคุกกี้จากบริการของบริษัทสาหรับวัตถุประสงค์ใด ๆ ที่ได้อธิบายไว้ข้างต้น ผู้ใช้บริการสามารถควบคุมโปรแกรมท่องเว็บของผู้ใช้บริการโดยทำการเปลี่ยนแปลงในแถบการตั้งค่าเพื่อหยุดการยอมรับคุกกี้หรือเพื่อเตือนผู้ใช้บริการก่อนการตกลงยอมรับคุกกี้จากเว็บไซต์ที่ผู้ใช้บริการเข้าไปเยี่ยมชม โปรดศึกษาข้อมูลเชิงเทคนิคของโปรแกรมท่องเว็บของผู้ใช้บริการอย่างไรก็ดีหากผู้ใช้บริการไม่ยอมรับคุกกี้ผู้ใช้บริการอาจไม่สามารถใช้ตัวเลือกการให้บริการที่บริษัทจัดให้ส่วนใดส่วนหนึ่งหรือทุก ๆ ส่วนหากผู้ใช้บริการมีคำถามเกี่ยวกับการยกเลิกหรือดัดแปลงคุกกี้โปรดติดต่อบริษัทตามข้อมูลติดต่อที่จัดไว้ให้ด้านล่าง
                </span>
                <span style={{ textAlign: "justify", textIndent: "5%" }}>
                    8.4 ผู้ใช้บริการสามารถหยุดการเก็บข้อมูลทั้งหมดโดยแอพพลิเคชั่นต่าง ๆ ได้โดยการถอนการติดตั้งแอพพลิเคชั่นผู้ใช้บริการอาจใช้การถอนการติดตั้งแบบมาตรฐานที่มีติดมาให้พร้อมกับอุปกรณ์โทรศัพท์มือถือของผู้ใช้บริการหรือผ่านตลาดแอพพลิเคชั่นทางโทรศัพท์หรือเครือข่ายเพื่อให้การบริการเป็นโฆษณาในแอพพลิเคชั่นของบริษัทที่ซึ่งเทคโนโลยีคุกกี้ไม่สามารถใช้งานได้ทางบริษัทอาจนำข้อมูลระบุอุปกรณ์ของผู้ใช้บริการกลับมาใช้ใหม่อีกครั้งผู้ใช้บริการอาจเลือกที่จะตั้งค่าเริ่มต้นหรือยกเลิก
                </span>
            </>
        )
    }

    function policy9() {
        return (
            <>
                <span>
                    สถานที่ติดต่อ : 3 อาคารพร้อมพันธุ์ 3 ชั้นที่ 9 ห้องเลขที่ 912ซอย ลาดพร้าว 3 แขวงจอมพล เขตจตุจักร กรุงเทพมหานคร 10900
                </span>
                <Row style={{ rowGap: "1vh" }}>
                    <span>
                        Email address เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
                    </span>
                    <span>
                        : sales@brightexpert.co.th
                    </span>
                </Row>

            </>
        )
    }

    function condition() {
        return (
            <span>
                ข้อตกลงและเงื่อนไข
            </span>
        )
    }

    function policyFooter() {
        return (
            <Flex vertical style={{ backgroundColor: "white", padding: "5vh" }}>
                <Row>
                    <Col span={18}>
                        <span>ข้าพเจ้าตกลงและยอมรับข้อตกลง</span>
                        <span>และเงื่อนไขตามที่บริษัทได้กำหนดไว้ทุกประการ</span>
                    </Col>
                    <Col span={6} style={{ textAlign: "right", alignContent: "center" }}>
                        <Switch onChange={handleSwitchChange} className={styles.customSwitch} />
                    </Col>
                </Row>
                <Row style={{ justifyContent: "center", marginTop: "3vh", gap: "3vw" }}>
                    <Button style={{ borderRadius: "2vh", width: "90px", height: "40px" }} disabled={isChecked}>ไม่ยอมรับ</Button>
                    <Button style={{ borderRadius: "2vh", width: "90px", height: "40px", backgroundColor: isChecked ? "#2FD159" : "", color: isChecked ? "white" : "" }} disabled={!isChecked} onClick={onAccept}>ยอมรับ</Button>
                </Row>
            </Flex>
        )
    }

    return {
        p1,
        p2,
        p3,
        p4,
        p5,
        p6,
        p7,
        p8,
        p9,
        p10,
        p11,
        p12,
        principle,
        policy1,
        policy2,
        policy3,
        policy4,
        policy5,
        policy6,
        policy7,
        policy8,
        policy9,
        condition,
        policyFooter
    }
}
export default usePolicy;